module.exports = "https://static.wanderu.com/ui-react/_next/static/media/it.290f2fec.svg";